export default __webpack_public_path__ + "static/media/triangle-exclamation-solid.34ce40de.svg";